import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  type = 'button',
  className = '',
  block = false,
  ...props
}) => {
  return (
    <button
      type={type}
      className={`app-button app-button--${variant} ${block ? 'app-button--block' : ''} ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
